$ = jQuery;
export const scroll = {
  init: function () {
    setTimeout(function(){scroll.reveal();}, 500)
    window.addEventListener("scroll", this.reveal);
  },
  reveal: function () {
    //REVEAL ANIMATION
    var reveals = document.querySelectorAll(".reveal");
    var revealsAnimations = document.querySelectorAll(".reveal-animation");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var pad = window.innerWidth < 1025 ? 80 : 150;
      var elementVisible = pad;
      if (elementTop < windowHeight) {
        reveals[i].classList.add("active");
      } else {
        reveals[i].classList.remove("active");
      }
    }
    for (var i = 0; i < revealsAnimations.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = revealsAnimations[i].getBoundingClientRect().top;
      var elementVisible = 50;
      if (elementTop < windowHeight - elementVisible) {
        revealsAnimations[i].classList.add("play");
      } else {
        revealsAnimations[i].classList.remove("play");
      }
    }

    //MENU ANCHORS ANIMATION
    var $anchor1 = document.getElementById("projetidentitaire");
    var $anchor2 = document.getElementById("ambition");
    var $anchor3 = document.getElementById("metamorphose");
    var $anchor4 = document.getElementById("evenements");
    var $anchorTop1 = $anchor1.getBoundingClientRect().top;
    var $anchorTop2 = $anchor2.getBoundingClientRect().top;
    var $anchorTop3 = $anchor3.getBoundingClientRect().top;
    var $anchorTop4 = $anchor4.getBoundingClientRect().top;

    if ($anchorTop1 < 250) {
      $("body").addClass("anchor1");
    } else {
      $("body").removeClass("anchor1");
    }
    if ($anchorTop2 < 250) {
      $("body").addClass("anchor2");
    } else {
      $("body").removeClass("anchor2");
    }
    if ($anchorTop3 < 250) {
      $("body").addClass("anchor3");
    } else {
      $("body").removeClass("anchor3");
    }
    if ($anchorTop4 < 250) {
      $("body").addClass("anchor4");
    } else {
      $("body").removeClass("anchor4");
    }

    //GRADIENT ANIMATION
    const $yGradient = document.getElementById("anima-gradient");
    const $yGradientTop = $yGradient.getBoundingClientRect().top;
    if ($yGradientTop < 250) {
      $("#metamorphose").addClass("show-gradient");
    } else {
      $("#metamorphose").removeClass("show-gradient");
    }
  },
};
